import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SystemIcon } from '@monorepo/nova-icons';
import {
  Box,
  IconButton,
  Typography,
  useBreakpoints,
  useTheme,
} from '@monorepo/nova-ui';
import { useNotifications } from '../../../hooks';

type Props = {
  readAllEnabled: boolean;
  setOpen: (open: boolean) => void;
};

export const NotificationsHeader: FC<Props> = ({ readAllEnabled, setOpen }) => {
  const { t } = useTranslation(['notificationCenter']);
  const { palette } = useTheme();
  const { isMobile } = useBreakpoints();
  const { handleReadAll } = useNotifications();

  return (
    <Box
      position="sticky"
      top={0}
      zIndex={1}
      display="flex"
      alignItems="center"
      height={56}
      minHeight={56}
      paddingX="16px"
      sx={{
        backgroundColor: isMobile
          ? palette.background.paper
          : palette.background.contrast,
      }}
    >
      {isMobile && (
        <IconButton onClick={() => setOpen(false)} sx={{ marginRight: 1 }}>
          <SystemIcon iconName="CaretLeft" size={18} />
        </IconButton>
      )}

      <Typography
        fontSize={isMobile ? 20 : 18}
        fontWeight={isMobile ? 600 : 400}
      >
        {t('notificationCenter:notifications')}
      </Typography>

      {isMobile ? (
        <IconButton onClick={() => setOpen(false)} sx={{ marginLeft: 'auto' }}>
          <SystemIcon iconName="X" size={16} />
        </IconButton>
      ) : (
        <Typography
          variant="button"
          onClick={readAllEnabled ? handleReadAll : undefined}
          color={readAllEnabled ? palette.primary.main : palette.grey[500]}
          sx={{
            marginLeft: 'auto',
            cursor: readAllEnabled ? 'pointer' : 'default',
            '&:hover': {
              color: readAllEnabled ? palette.primary.light : undefined,
            },
          }}
        >
          {t('notificationCenter:read_all')}
        </Typography>
      )}
    </Box>
  );
};
